// extracted by mini-css-extract-plugin
module.exports = {"list":"styles__list___1vwH7","itemContent":"styles__itemContent___2KowM"};